/* React base class */
import { Component } from "react"

/* Redux store connection */
import { connect } from "react-redux"

/* Router HOC */
import { withRouter, applySeo } from "../../helpers"

/* Shared UI components */
import { Account, Loading } from "../../components"

/* Icon component */
import Icon from "../../components/Icon"

/* Support API: FAQ list and ticket submit */
import { faq, ticket } from "../../api/Support"

/* i18n */
import { translate } from "../../translates"

/* Page Help */
class Help extends Component {

    constructor(props) {
        super(props)

        /* State */
        this.state = {
            loading: true,
            faq: [],
            open: 0,
            subject: "",
            message: "",
            touched: false,
            sent: false,
            error: null
        }
    }

    componentDidMount = () => {

        /* SEO */
        applySeo({ title: `Помощь и поддержка — Bookify`, description: `Ответы на частые вопросы о Bookify: как записаться онлайн, отменить запись, оставить отзыв и пользоваться подарочными сертификатами.`, keywords: `помощь Bookify, поддержка, частые вопросы, как записаться онлайн`, path: `/help` })

        /* Scroll */
        window.scroll(0, 0)

        /* Get FAQ Data */
        faq().then((response) => {
            this.setState({ faq: response && response.status === 200 ? response.data : [], loading: false })
        })
    }

    /* Draw Submit */
    _submit = () => {

        /* Fields */
        const { subject, message } = this.state
        const { token, toggleAuth } = this.props

        /* Validate */
        this.setState({ touched: true, error: null })
        if (subject.trim().length < 3 || message.trim().length < 10) {
            return
        }

        /* Ticket endpoint needs an authenticated user — offer sign in instead of failing silently */
        if (!token) {
            toggleAuth(true)
            return
        }

        /* Send Ticket */
        ticket(token, { subject: subject.trim(), message: message.trim() }).then((response) => {
            if (response && (response.status === 201 || response.status === 200)) {
                this.setState({ sent: true, subject: "", message: "", touched: false, error: null })
            }
            else {
                this.setState({ error: "Не удалось отправить сообщение. Попробуйте ещё раз или напишите на info@bookify.kz" })
            }
        })
    }

    /* Draw Form */
    _form = () => {

        /* Fields */
        const { sent, subject, message, touched, error } = this.state

        /* Status */
        const subjectError = touched && subject.trim().length < 3
        const messageError = touched && message.trim().length < 10

        /* Sent */
        if (sent) {
            return (
                <div className="help__sent">
                    <div className="help__sent-check"><Icon name="check" size={28} /></div>
                    <h3>{translate("Сообщение отправлено!")}</h3>
                    <p>Спасибо за обращение. Мы ответим на <b>info@bookify.kz</b> в течение рабочего дня.</p>
                    <button className="btn btn--ghost" onClick={() => this.setState({ sent: false })}>{translate("Написать ещё")}</button>
                </div>
            )
        }

        /* Form */
        return (
            <div className="help__form">
                <div className="field">
                    <label className="field__label">{translate("Тема")}</label>
                    <input className={subjectError ? "input input--error" : "input"} placeholder="Кратко опишите проблему" value={subject} onChange={(event) => this.setState({ subject: event.target.value })} />
                    {subjectError && <div className="field__err">Укажите тему (от 3 символов)</div>}
                </div>
                <div className="field">
                    <label className="field__label">{translate("Сообщение")}</label>
                    <textarea className={messageError ? "input input--error" : "input"} placeholder="Расскажите, что произошло..." value={message} onChange={(event) => this.setState({ message: event.target.value })} />
                    <div className={messageError ? "field__err" : "field__hint"}>
                        {messageError ? "Опишите подробнее (от 10 символов)" : "Минимум 10 символов"}
                    </div>
                </div>
                {error && <div className="field__err help__error">{error}</div>}
                <button className="btn btn--block btn--lg" onClick={this._submit}>{translate("Отправить")}</button>
            </div>
        )
    }

    /* Draw FAQ */
    _faq = () => {

        /* Fields */
        const { loading, faq, open } = this.state

        /* Loading */
        if (loading) {
            return <Loading inline />
        }

        /* List */
        return (
            <div className="help__faq">
                {Array.isArray(faq) && faq.map((item, index) => (
                    <div key={`${index}`} className="help__faq-item">
                        <button className="help__faq-q" onClick={() => this.setState({ open: open === index ? -1 : index })}>
                            {item.q}
                            <Icon name={open === index ? "minus" : "plus"} size={16} />
                        </button>
                        {open === index && <p className="help__faq-a">{item.a}</p>}
                    </div>
                ))}
            </div>
        )
    }

    render = () => {
        return (
            <Account active="help">
                <div className="content">

                    <h2 className="content__title">{translate("Помощь и обратная связь")}</h2>
                    <p className="content__subtitle">
                        Напишите о проблеме или вопросе — мы ответим в течение рабочего дня на{" "}
                        <a className="help__mail" href="mailto:info@bookify.kz">info@bookify.kz</a>
                    </p>

                    <div className="help__grid">
                        <div>{this._form()}</div>
                        <div>
                            <h3 className="help__faq-title">{translate("Частые вопросы")}</h3>
                            {this._faq()}
                        </div>
                    </div>

                </div>
            </Account>
        )
    }
}

/* Map State To Props */
const mapStateToProps = state => {
    return {
        token: state.token,
        lang: state.lang
    }
}

/* Map Dispatch To Props */
const mapDispatchToProps = dispatch => {
    return {
        toggleAuth: data => dispatch({ type: "TOGGLE_AUTH", payload: data })
    }
}

/* Export */
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Help))
